import { useState } from "react";
import { useT } from "@/lib/i18n";

const LAYERS = [["rain", "ecmwf"], ["radar", "radar"], ["wind", "ecmwf"]];

export const RadarPanel = ({ lat, lon, h = 520 }) => {
  const { t } = useT();
  const [layer, setLayer] = useState("rain");
  const product = LAYERS.find(([l]) => l === layer)[1];
  const src = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=%C2%B0C&metricWind=km%2Fh&zoom=${layer === "radar" ? 9 : 7}`
    + `&overlay=${layer}&product=${product}&level=surface&lat=${lat}&lon=${lon}&detailLat=${lat}&detailLon=${lon}&marker=true&message=true&calendar=now&pressure=false`;
  return (
    <section data-testid="weather-radar" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-3 flex flex-col h-full">
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mr-auto">{t("wx_radar")}</span>
        {LAYERS.map(([l]) => (
          <button key={l} type="button" data-testid={`weather-radar-${l}-btn`} onClick={() => setLayer(l)}
            className={`px-2.5 py-1 rounded-sm border font-mono text-[11px] uppercase transition-colors duration-200 ${layer === l ? "border-[#FF3B30] text-white bg-[#FF3B30]/15" : "border-[#282D3D] text-slate-400 hover:text-white"}`}>
            {t(`wx_layer_${l}`)}
          </button>
        ))}
      </div>
      <iframe key={src} data-testid="weather-radar-frame" title="radar" src={src} className="w-full flex-1 rounded-sm border-0" style={{ minHeight: h || undefined }} />
    </section>
  );
};
